import { Link } from "@tanstack/react-router";

const SERVICE_LINKS = [
  { to: "/lead-generation-tools", label: "Lead Generation Tools" },
  { to: "/visualizers", label: "Visualizers" },
  { to: "/event-landing-pages", label: "Landing Pages" },
  { to: "/custom-app-builds", label: "Custom App Builds" },
  { to: "/squarespace-websites", label: "Squarespace Websites" },
  { to: "/squarespace-migrations", label: "Squarespace Migrations" },
  { to: "/linkedin-advertising", label: "LinkedIn Advertising" },
  { to: "/seo-ai-visibility", label: "SEO & AI Visibility" },
  { to: "/b2b-lead-magnets", label: "Resources: B2B Lead Magnets" },
  { to: "/php-vulnerability-squarespace", label: "Resources: PHP Vulnerability & Squarespace" },
  { to: "/about", label: "About" },
] as const;

const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/eula", label: "Terms" },
] as const;

export function Footer() {
  return (
    <footer className="px-6 md:px-8 lg:px-12 py-10 md:py-12 border-t border-border/50">
      <div className="max-w-6xl mx-auto flex flex-col gap-8">
        <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-6 gap-y-3">
          {SERVICE_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </Link>
          ))}
          {LEGAL_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <img
            src="https://apps.squaremigration.com/images/design-mode/logofile.png"
            alt="Square Migration"
            className="h-8 w-auto"
          />
          <div className="flex flex-col items-center gap-3 sm:items-end">
            <p className="text-xs text-muted-foreground">
              Text or call to discuss your project:{" "}
              <a
                href="tel:+16127101772"
                className="text-foreground hover:text-primary transition-colors"
              >
                612-710-1772
              </a>
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/in/chrisgouldmn"
                target="_blank"
                rel="noreferrer"
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                LinkedIn
              </a>
              <p className="text-xs text-muted-foreground">
                © {new Date().getFullYear()} Square Migration. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
